// getShouldShowEmailBindingHint.js
'use strict';
import { JWT_SCOPE_CREATOR } from '../RemoteConfigKeys.js';

import { createSelector } from '../resource/createCachedSelector.js';

import getMeData from '../selector/getMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';
import getIsPermissionMatched from '../selector/getIsPermissionMatched.js';
import { CONFIG_PRIORITY_PRESENCE_USER } from '../resource/configPriority.js';
import { getIsChinaPartner } from '../resource/partner.js';

/**
 * Select should show email binding hint by me
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {boolean} will return true when user is not CP and have not bound email.
 */
const getShouldShowEmailBindingHint = createSelector(
  state => !!getNetworkingData(state, ['me', 'accountLinks'], 'isFetched'),
  state => !!getMeData(state, 'isEmailBound'),
  state => getIsPermissionMatched(state, JWT_SCOPE_CREATOR),
  state => getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_USER),
  (
    isAccountLinksFetched,
    isEmailBound,
    isCP,
    isPresenceUserRemoteConfigMerged
  ) => {
    const isChinaPartner = getIsChinaPartner();
    return (
      isAccountLinksFetched &&
      !isEmailBound &&
      !isCP &&
      !isChinaPartner &&
      isPresenceUserRemoteConfigMerged
    );
  }
);

export default getShouldShowEmailBindingHint;
